import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportAvgResponseTime_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportAvgResponseTime extends Report<ReportAvgResponseTime_Settings> {

    static reportName   : string = "Avg. response time"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_AVG_RESPONSE_TIME
        super(data);

        this.icon        = "isvg-avg-response"
        this.description = "Displays the average response time for tasks or messages, providing insights into efficiency and responsiveness."

        this.settings    = new ReportAvgResponseTime_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView): ReportAvgResponseTime {
        return new ReportAvgResponseTime(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportAvgResponseTime_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
